import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default (state = initialState.codeProductsPage, action) => {
  switch (action.type) {
    case types.SET_CODE_PRODUCTS_PAGE:
      return {
        ...state,
        page: action.page,
      };
    case types.RESET_CODE_PRODUCTS_PAGE:
      return {
        ...initialState.codeProductsPage,
      };
    default:
      return state;
  }
};
